import { ShopifyService, ShopifyStoreAccount } from 'src/app/Services/shopify-service/shopify.service';
import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { PlateformCurrencyExchangeRate, WixService } from 'src/app/Services/Wix-Service/wix.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { ViewArtistProductResponse } from 'src/app/models/viewartistproductresponse.model';
import { NotificationTypes } from 'src/app/app.enums';
import { StoreDetail, WoocomerceService, WooCommerceAccount } from 'src/app/Services/woocomerce-service/woocomerce.service';
import { SquareupPosService } from 'src/app/Services/squareup-pos.service.ts/squareup-pos.service';
import { SingleProductSyncComponent } from '../single-product-sync/single-product-sync-component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArtistProductSummary } from 'src/app/Services/artistproducts.service';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { SquareSpaceService } from 'src/app/Services/square-space/square-space.service';

@Component({
    selector: 'app-currency-exchange-dialog',
    templateUrl: './currency-exchange-dialog.component.html',
    inputs: ['displayCurrencyDialog', 'selectedItem', 'selectedPlatform', 'ArtistProductSummary'],
    outputs: ['useNewRate', 'closeDialog', 'useNewRateManually'],
    standalone: false
})
export class CurrencyExchangeDialogComponent implements OnInit, OnChanges {
    @ViewChild(SingleProductSyncComponent) syncSingleProductComponent!: SingleProductSyncComponent;
    public displayCurrencyDialog!: boolean;
    public selectedPlatform!: string;
    public selectedItem: ViewArtistProductResponse = {} as ViewArtistProductResponse;
    public ArtistProductSummary!: ArtistProduct;
    public useNewRate = new EventEmitter<void>();
    public useNewRateManually = new EventEmitter<void>();
    public closeDialog = new EventEmitter<void>();
    public ConvertedPrice: number = 0;
    public Productprice: any;
    public isLoading: boolean = true;
    public exchangeRateData: PlateformCurrencyExchangeRate | null = null;
    public isContinueButtonDisabled: boolean = true;
    public StoreDetail: StoreDetail[] | any[] = [];
    public ShopifyStoreAccount: ShopifyStoreAccount[] = [];
    public selectedStoreId: any;
    public authConfig!: AuthConfig;
    public squareSpaceStorePages: any[] = [];
    public selectedSquareSpaceStorePage: any;

    constructor(
        private wixService: WixService,
        private ShopifyService: ShopifyService,
        private ngxSpinnerService: NgxSpinnerService,
        private notificationsService: NotificationsService,
        private WoocomerceService: WoocomerceService,
        private SquareupPosService: SquareupPosService,
        private authService: AuthService,
        private squareSpaceService: SquareSpaceService,
        private cdr: ChangeDetectorRef
    ) { }

    public ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['displayCurrencyDialog'] && this.displayCurrencyDialog) {
            this.handleDialogOpen();
        }
    }

    private handleDialogOpen(): void {
        if (this.selectedPlatform === 'WooCommerce') {
            this.getWoocommerceAccountDialog();
        }
        else if (this.selectedPlatform === 'Shopify') {
            this.getShopifyAccounts();
        }
        else if (this.selectedPlatform === 'SquareSpace') {
            this.getSquareSpaceAccounts();
        }
        else {
            this.checkAndSyncProduct(this.selectedPlatform);
        }
    }

    public getWoocommerceAccountDialog(): void {
        this.isLoading = false;
        this.ngxSpinnerService.show();

        this.WoocomerceService.getWoocommerceAccountDetails(false).subscribe(
            (response) => {
                this.ngxSpinnerService.hide();
                if (response) {
                    this.StoreDetail = response;
                }
            },
            (error) => {
                this.ngxSpinnerService.hide();
                console.error('Error fetching Woocommerce account details:', error);
            }
        );
    }

    public getSquareSpaceAccounts() {
        this.isLoading = false;
        this.squareSpaceService.getSquareSpaceAccountDetails().subscribe(
            (response: any) => {
                if (response) {
                    this.ngxSpinnerService.hide();
                    this.StoreDetail = response;
                    this.cdr.detectChanges();
                }
            },
            (error) => {
                this.ngxSpinnerService.hide();
                console.error('Error fetching SquareSpace account details:', error);
            }
        );
    }

    public getShopifyAccounts(): void {
        this.isLoading = false;
        this.ngxSpinnerService.show();

        this.ShopifyService.getShopifyAccounts().subscribe(
            (response) => {
                this.ngxSpinnerService.hide();
                if (response) {
                    this.ShopifyStoreAccount = response;
                }
            },
            (error) => {
                this.ngxSpinnerService.hide();
                console.error('Error fetching Shopify account details:', error);
            }
        );
    }

    onStoreChange(event: any): void {
        if (!event.value) return;

        this.selectedStoreId = event.value;
        if (this.selectedPlatform === 'WooCommerce') {
            const selectedStore = this.StoreDetail.find(store => store.Id === event.value);
            if (selectedStore) {
                this.isLoading = true;
                this.storeCurrencyofWoocommerceWithExchangeRate(selectedStore);
            }
        }
        else if (this.selectedPlatform === 'Shopify') {
            const selectedStore = this.ShopifyStoreAccount.find(store => store.Id === event.value);
            if (selectedStore) {
                this.isLoading = true;
                this.storeCurrencyofShopifyWithExchangeRate(selectedStore);
            }
        }
        else if (this.selectedPlatform === 'SquareSpace') {
            this.squareSpaceService.getSquareSpaceStorePages(this.selectedStoreId).subscribe((response: any) => {
                if (response.Success) {
                    this.squareSpaceStorePages = response.ResponseData.storePages;
                }
            });
        }
    }

    getStoreOptions(): any[] {
        switch (this.selectedPlatform) {
            case 'WooCommerce': return this.StoreDetail || [];
            case 'Shopify': return this.ShopifyStoreAccount || [];
            case 'SquareSpace': return this.StoreDetail || [];
            default: return [];
        }
    }

    getStoreOptionLabel(): string {
        switch (this.selectedPlatform) {
            case 'WooCommerce': return 'StoreName';
            case 'SquareSpace': return 'SiteInfo.title';
            case 'Shopify': return 'StoreName';
            default: return 'name';
        }
    }

    onSquareSpacePageChange(event: any) {
        this.selectedSquareSpaceStorePage = event.value;
        this.isLoading = true;
        this.storeCurrencyOgSquareSpaceWithExchangeRate();
    }

    public storeCurrencyofWixWithExchangeRate(): void {
        this.handleCurrencyExchangeRequest(
            this.wixService.storeCurrencyofWixWithExchangeRate(),
            'Wix'
        );
    }

    public storeCurrencyofShopifyWithExchangeRate(store: ShopifyStoreAccount): void {
        this.handleCurrencyExchangeRequest(
            this.ShopifyService.storeCurrencyofShopifyWithExchangeRate(store.Id),
            'Shopify'
        );
    }

    public storeCurrencyofWoocommerceWithExchangeRate(store: StoreDetail): void {
        this.handleCurrencyExchangeRequest(
            this.WoocomerceService.storeCurrencyofWoocommerceWithExchangeRate(store.Id),
            'WooCommerce'
        );
    }

    public storeCurrencyofsquareUpWithExchangeRate(): void {
        this.handleCurrencyExchangeRequest(
            this.SquareupPosService.storeCurrencyofsquareUpWithExchangeRate(),
            'SquareUp'
        );
    }

    public storeCurrencyOgSquareSpaceWithExchangeRate() {
        this.handleCurrencyExchangeRequest(
            this.squareSpaceService.storeCurrencyOfsquareSpaceWithExchangeRateCurrency(this.selectedStoreId),
            'SqaureSpace'
        );
    }

    private handleCurrencyExchangeRequest(observable: any, platformName: string): void {
        observable.subscribe({
            next: (response: PlateformCurrencyExchangeRate) => {
                this.processExchangeRateResponse(response);
            },
            error: (error: any) => {
                this.handleCurrencyExchangeError(error, platformName);
            },
        });
    }

    private processExchangeRateResponse(response: PlateformCurrencyExchangeRate): void {
        this.exchangeRateData = response;
        this.isLoading = false;
        this.isContinueButtonDisabled = !(response.ResponseObject?.Success);

        if (response?.IsPlateformCurrencyIsDifferent && response?.ResponseObject?.Success) {
            if (this.authConfig?.IsGallery) {
                this.Productprice = this.selectedItem?.RetailPrice
                this.ConvertedPrice = this.selectedItem?.RetailPrice! * response.ExchangeRate;
            }
            else if (this.authConfig?.IsArtist) {
                this.Productprice = this.ArtistProductSummary?.ArtistRevenue
                this.ConvertedPrice = this.ArtistProductSummary?.ArtistRevenue! * response.ExchangeRate;
            }
            else {
                this.ConvertedPrice = this.selectedItem?.RetailPrice! * response.ExchangeRate;
            }
        } else if (!response.IsPlateformCurrencyIsDifferent && response.ResponseObject.Success) {
            // Show message and enable button, do not auto-sync
            this.isContinueButtonDisabled = false;
        }
    }

    private handleCurrencyExchangeError(error: any, platformName: string): void {
        console.error(`Error in ${platformName} currency exchange:`, error);
        this.displayCurrencyDialog = false;
        this.isLoading = false;
    }

    public checkAndSyncProduct(platform: string): void {
        switch (platform) {
            case 'SquareUp':
                this.storeCurrencyofsquareUpWithExchangeRate();
                break;
            case 'Shopify':
                this.getShopifyAccounts();
                break;
            case 'WooCommerce':
                this.getWoocommerceAccountDialog();
                break;
            case 'Wix':
                this.storeCurrencyofWixWithExchangeRate();
                break;
        }
    }

    public onUseNewRate(): void {
        this.closeDialog.emit();
        this.syncToSingleProduct(this.selectedPlatform, false);
    }

    public onUseManualRate(): void {
        this.closeDialog.emit();
        this.syncToSingleProduct(this.selectedPlatform, true);
    }

    public onHideDialog(): void {
        this.closeDialog.emit();
        this.selectedStoreId = null;
        this.exchangeRateData = null;
    }

    private syncToSingleProduct(platform: string, IsManual: boolean): void {
        switch (platform) {
            case 'SquareUp':
                this.syncSingleProductComponent.onProductSynctoSquare(IsManual);
                break;
            case 'Shopify':
                if (this.authConfig?.IsArtist) {
                    this.syncSingleProductComponent.artistOnProductSyncShopify(IsManual);
                }
                else if (this.authConfig?.IsGallery) {
                    this.syncSingleProductComponent.onProductSyncToShopify(IsManual);
                }
                break;
            case 'WooCommerce':
                if (this.authConfig?.IsArtist) {
                    this.syncSingleProductComponent.artistOnProductSyncWoocommerce(IsManual);
                }
                else if (this.authConfig?.IsGallery) {
                    this.syncSingleProductComponent.onProductSyncWoocommerce(IsManual);
                }
                break;
            case 'Wix':
                this.syncSingleProductComponent.syncProductWithWix(IsManual);
                break;
            case 'SquareSpace':
                if (this.authConfig?.IsArtist) {
                    this.syncSingleProductComponent.ArtistProductSyncToSquareSpace(IsManual);
                } else if (this.authConfig?.IsGallery) {
                    this.syncSingleProductComponent.onProductSyncToSquareSpace(IsManual);
                }
        }
    }
}